// Hand-crafted SVG paths for room mascots.
// Each character has one or more `<path>` elements with `stroke-dasharray/dashoffset`
// so we can animate the stroke drawing on hover (pen-on-paper effect).
window.BLC_CHARACTERS = {
  kitchen: `
    <svg viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#2a1f1c" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
      <!-- Pomegranate body (main outline) -->
      <path class="draw-path" d="M 120 60
              C 80 60, 50 95, 50 140
              C 50 190, 90 220, 120 220
              C 150 220, 190 190, 190 140
              C 190 95, 160 60, 120 60 Z" />
      <!-- Crown / top -->
      <path class="draw-path" d="M 108 62 L 112 45 L 116 60 L 120 42 L 124 60 L 128 45 L 132 62" />
      <!-- Left eye -->
      <path class="draw-path" d="M 100 130 a 4 4 0 1 0 0.1 0 Z" stroke-width="8" />
      <!-- Right eye -->
      <path class="draw-path" d="M 140 130 a 4 4 0 1 0 0.1 0 Z" stroke-width="8" />
      <!-- Smile -->
      <path class="draw-path" d="M 108 155 Q 120 168 132 155" />
      <!-- Left cheek blush -->
      <ellipse class="draw-blush" cx="90" cy="150" rx="10" ry="6" fill="#ffb3c8" stroke="none" />
      <!-- Right cheek blush -->
      <ellipse class="draw-blush" cx="150" cy="150" rx="10" ry="6" fill="#ffb3c8" stroke="none" />
      <!-- Highlight -->
      <path class="draw-path" d="M 75 105 Q 78 115 82 108" opacity="0.6" />
      <!-- Citrus slice (bottom right) -->
      <path class="draw-path" d="M 175 200
              A 30 30 0 0 0 220 195
              L 175 200 Z" fill="#fff4a8" />
      <path class="draw-path" d="M 180 200 L 200 195" />
      <path class="draw-path" d="M 185 205 L 205 195" />
      <path class="draw-path" d="M 190 208 L 208 198" />
      <path class="draw-path" d="M 195 210 L 212 200" />
    </svg>`,

  bathroom: `
    <svg viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#2a1f1c" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
      <!-- Sparkle 1 -->
      <path class="draw-path" d="M 70 60 L 74 68 L 82 72 L 74 76 L 70 84 L 66 76 L 58 72 L 66 68 Z" />
      <!-- Sparkle 2 (bigger) -->
      <path class="draw-path" d="M 155 45 L 160 58 L 173 63 L 160 68 L 155 81 L 150 68 L 137 63 L 150 58 Z" />
      <!-- Bathtub body -->
      <path class="draw-path" d="M 40 140
              L 40 175
              Q 40 195 60 195
              L 180 195
              Q 200 195 200 175
              L 200 140" />
      <!-- Bathtub rim -->
      <path class="draw-path" d="M 30 140 L 210 140" stroke-width="5" />
      <!-- Left claw foot -->
      <path class="draw-path" d="M 60 195 L 60 210 Q 60 218 68 218 Q 76 218 76 210 L 76 195" />
      <!-- Right claw foot -->
      <path class="draw-path" d="M 164 195 L 164 210 Q 164 218 172 218 Q 180 218 180 210 L 180 195" />
      <!-- Rubber duck body -->
      <ellipse class="draw-shape" cx="140" cy="130" rx="26" ry="18" fill="#ffd93d" stroke="#2a1f1c" stroke-width="3" />
      <!-- Duck head -->
      <circle class="draw-shape" cx="160" cy="115" r="14" fill="#ffd93d" stroke="#2a1f1c" stroke-width="3" />
      <!-- Duck beak -->
      <path class="draw-path" d="M 172 115 L 180 117 L 172 120 Z" fill="#ff8a3d" stroke-width="2" />
      <!-- Duck eye -->
      <circle class="draw-shape" cx="162" cy="112" r="1.6" fill="#2a1f1c" stroke="none" />
      <!-- Water line in tub -->
      <path class="draw-path" d="M 50 148 Q 70 145 90 148 T 130 148 T 170 148 T 200 148" opacity="0.4" />
    </svg>`,

  glass: `
    <svg viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#2a1f1c" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
      <!-- Window frame outer -->
      <rect class="draw-shape" x="50" y="50" width="140" height="140" rx="8" />
      <!-- Window frame inner border (thicker) -->
      <rect class="draw-shape" x="60" y="60" width="120" height="120" rx="4" stroke-width="3" opacity="0.5" />
      <!-- Sparkle top-left -->
      <path class="draw-path" d="M 85 90 L 88 98 L 96 101 L 88 104 L 85 112 L 82 104 L 74 101 L 82 98 Z" />
      <!-- Sparkle top-right -->
      <path class="draw-path" d="M 155 85 L 159 96 L 170 100 L 159 104 L 155 115 L 151 104 L 140 100 L 151 96 Z" />
      <!-- Sparkle bottom-left small -->
      <path class="draw-path" d="M 80 165 L 82 170 L 87 172 L 82 174 L 80 179 L 78 174 L 73 172 L 78 170 Z" />
      <!-- Sparkle bottom-right -->
      <path class="draw-path" d="M 158 160 L 160 166 L 166 168 L 160 170 L 158 176 L 156 170 L 150 168 L 156 166 Z" />
      <!-- Left eye -->
      <circle class="draw-shape" cx="105" cy="130" r="3" fill="#2a1f1c" stroke="none" />
      <!-- Right eye -->
      <circle class="draw-shape" cx="135" cy="130" r="3" fill="#2a1f1c" stroke="none" />
      <!-- Smile -->
      <path class="draw-path" d="M 108 148 Q 120 158 132 148" />
      <!-- Shine streak -->
      <path class="draw-path" d="M 70 65 L 90 90" opacity="0.4" stroke-width="2" />
    </svg>`,

  floors: `
    <svg viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#2a1f1c" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
      <!-- Mop handle -->
      <path class="draw-path" d="M 155 40 L 105 155" stroke-width="6" stroke="#7ab8dd" />
      <!-- Handle top cap -->
      <circle class="draw-shape" cx="157" cy="38" r="6" fill="#7ab8dd" stroke="#2a1f1c" stroke-width="2" />
      <!-- Mop head base -->
      <path class="draw-path" d="M 60 165
              Q 55 155 65 152
              L 145 152
              Q 155 155 150 165
              Q 152 180 105 185
              Q 58 180 60 165 Z" fill="#f5f0e3" />
      <!-- Mop strand wiggles -->
      <path class="draw-path" d="M 70 175 Q 72 182 68 188" />
      <path class="draw-path" d="M 82 178 Q 84 185 80 192" />
      <path class="draw-path" d="M 95 180 Q 97 187 93 193" />
      <path class="draw-path" d="M 110 180 Q 112 187 108 193" />
      <path class="draw-path" d="M 125 178 Q 127 185 123 192" />
      <path class="draw-path" d="M 140 175 Q 142 182 138 188" />
      <!-- Smile -->
      <path class="draw-path" d="M 95 170 Q 105 176 115 170" />
      <!-- Eyes -->
      <circle class="draw-shape" cx="90" cy="163" r="1.8" fill="#2a1f1c" stroke="none" />
      <circle class="draw-shape" cx="120" cy="163" r="1.8" fill="#2a1f1c" stroke="none" />
      <!-- Sparkles around mop head -->
      <path class="draw-path" d="M 40 130 L 43 137 L 50 140 L 43 143 L 40 150 L 37 143 L 30 140 L 37 137 Z" />
      <path class="draw-path" d="M 175 140 L 178 148 L 186 151 L 178 154 L 175 162 L 172 154 L 164 151 L 172 148 Z" />
      <path class="draw-path" d="M 165 95 L 167 100 L 172 102 L 167 104 L 165 109 L 163 104 L 158 102 L 163 100 Z" />
    </svg>`
};
